import { BusStop, IBusStop, IBusStopData } from "@/domain/entities/busStop";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import { HttpBusStop, IBusStopParser } from "../lineInfoRepository.types";
import dayjs from "dayjs";

// 내 근처 정류장 찾기용
@injectable()
export class BusStopParser implements IBusStopParser {
  constructor() {}

  toDomain(data: HttpBusStop): Result<IBusStop, ParseError> {
    try {
      const busStopData: IBusStopData = {
        id: data.uid,
        number: data.no,
        name: data.name,
        shortName: data.name,
        departureTime: "",
        arrivalTime: "",
        isFirstStop: data.beginYn,
        isLastStop: data.finalYn,
        isGetOnStop: data.onYn,
        isGetOffStop: data.offYn,
        isTransitStop: data.transYn,
        isDisplayStop: data.displayYn,
        isOmitted: data.omittedYn,
        isTemp: data.tempYn,
        shouldShowStreetView: data.streetViewYn,
        latitude: data.lat,
        longitude: data.lng,
        direction: "",
        shouldNotice: false,
        // 몇 분 후 도착
        remainingTimeMin: -1,
        isMyBoardingStop: false,
        distance: data.distanceM,
        transferBusStops: data.trans?.routes,
        transferGuide: data.trans?.transText,
        isFavorite: data.isFavorite ?? false,
        useBeginDtm: dayjs(data.useBeginDtm).format("YYYY-MM-DD HH:mm"),
        useEndDtm: data.useEndDtm
          ? dayjs(data.useEndDtm).format("YYYY-MM-DD HH:mm")
          : undefined,
      };
      const busStop = new BusStop(busStopData);
      return ok(busStop);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
